<template>
    <nav v-if="meta?.total" class="pagination">
        <div class="col-xs-12 col-md-6 col-lg-9">
            <ul class="page-list clearfix text-md-right text-xs-center">
            
            <li>
                <a 
                    rel="prev"
                    class="previous js-search-link cursor-pointer"
                    :class="{ 'disabled': meta.current_page === 1 }"
                    @click.prevent="previousPageClicked"
                >
                    <i class="fa fa-long-arrow-left"></i><span>Previous</span>
                </a>
            </li>

            <li 
                v-for="(page, index) in pages"
                :key="`page-${index}`"
                :class="{ 'current': page === meta.current_page }"
            >
                <a 
                    rel="nofollow"
                    class="js-search-link cursor-pointer"
                    :class="{ 'disabled': page === meta.current_page }"
                    @click.prevent="pageClick(page)"
                >
                    {{ page }}
                </a>
            </li>

            <li>
                <a 
                    rel="next"
                    class="next js-search-link cursor-pointer"
                    :class="{ 'disabled': meta.current_page === meta.last_page }"
                    @click.prevent="nextPageClicked"
                >
                    <span>Next</span><i class="fa fa-long-arrow-right"></i>
                </a>
            </li>

            </ul>
        </div>
    </nav>

</template>

<script setup>
import { computed, ref } from 'vue';
// import {
//     PAGINATION_PER_PAGE_OPTIONS,
//     PAGINATION_DEFAULT_PER_PAGE,
// } from '@/config/pagination.config';
// import SelectField from '@/components/base/form/SelectField.vue';
import { usePaginationStore } from '@/stores/common/pagination.store'; // adjust path

const emit = defineEmits(['change:page', 'change:perPage']);

const props = defineProps({
    meta: {
        type: Object,
        default: () => ({}),
    },
});

const localPerPage = ref(props.meta?.per_page ?? 10);
const pages = computed(() => {
    let data = [];
    let i = 1;

    while (i <= props.meta.last_page) {
        if (
            i <= 3 ||
            i >= props.meta.last_page - 2 ||
            (i >= props.meta.current_page - 1 &&
                i <= props.meta.current_page + 1)
        ) {
            data.push(i);
            i++;
        } else {
            data.push('...');
            i =
                i < props.meta.current_page
                    ? props.meta.current_page - 1
                    : props.meta.last_page - 2;
        }
    }

    return data;
});

const goToPage = ref();

const paginationStore = usePaginationStore();

const nextPageClicked = () => {
  const targetPage = props.meta.current_page + 1;
  if (targetPage <= props.meta.last_page) {
    paginationStore.setCurrentPage(targetPage); // <<< Update store
    emit('change:page', targetPage);
  }
};

const previousPageClicked = () => {
  const targetPage = props.meta.current_page - 1;
  if (targetPage >= 1) {
    paginationStore.setCurrentPage(targetPage); // <<< Update store
    emit('change:page', targetPage);
  }
};

const pageClick = (page) => {
  goToPage.value = null;
  paginationStore.setCurrentPage(page || 1); // <<< Update store
  emit('change:page', page || 1);
};

</script>

<style scoped>
    a:not([href]):not([tabindex]):hover {
        color: white;
        text-decoration: none;
    }
</style>
